import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const errornotify = (text:string) => toast(text, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
export const successnotify = (text:String) => toast(text, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
